import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Projects = () => {
  const projects = [
    {
      title: "Control total de stock en tiempo real",
      description:
        "Sistema para registrar consumos y movimientos con actualización inmediata, evitando faltantes, errores y desorden en la gestión.",
      tech: ["Stock", "Control en tiempo real", "Alertas", "Acceso remoto"],
    },
    {
      title: "Gestión de negocio con control de precios",
      description:
        "Sistema con escaneo desde el celular, actualización rápida de precios y generación de etiquetas QR para mantener todo organizado.",
      tech: ["QR", "Ventas", "Precios", "Gestión"],
    },
    {
      title: "Biblioteca digital institucional",
      description:
        "Centralización de documentos, manuales y capacitaciones para acceso rápido y ordenado por parte del equipo.",
      tech: ["Documentos", "Acceso rápido", "Organización"],
    },
    {
      title: "Seguimiento completo de taller",
      description:
        "Sistema para órdenes de trabajo, ventas y stock, con seguimiento de clientes, historial y alertas automáticas.",
      tech: ["Órdenes", "Seguimiento", "Alertas", "Historial"],
    },
  ];

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex px-4 py-2 rounded-full bg-slate-100 text-slate-700 text-sm font-semibold mb-4">
            Casos reales
          </span>

          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Soluciones que ya están funcionando
          </h2>

          <p className="text-xl text-slate-600">
            Ejemplos reales de sistemas desarrollados para ordenar procesos, reducir errores y mejorar el control en distintos entornos de trabajo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">
          {projects.map((project) => (
            <Card
              key={project.title}
              className="border-slate-200 rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <CardHeader>
                <CardTitle className="text-2xl text-slate-900 leading-snug">
                  {project.title}
                </CardTitle>

                <CardDescription className="text-slate-600 text-base leading-relaxed">
                  {project.description}
                </CardDescription>
              </CardHeader>

              <CardContent>
                <div className="space-y-4">
                  <p className="text-sm font-semibold uppercase tracking-wider text-slate-500">
                    Incluye
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {project.tech.map((tech) => (
                      <Badge
                        key={tech}
                        variant="secondary"
                        className="bg-blue-50 text-blue-700 hover:bg-blue-100 rounded-full px-3 py-1"
                      >
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;